import React, { useState, useEffect } from 'react';
import Table from 'react-bootstrap/Table';
import axios from 'axios';
import ProduktList from '../../components/Produkt/ProduktList';
import { getProducentStorage } from '../../dao/DAO';
import './KatalogStart.css';
const DAO_PRODUCENT_URL = process.env.REACT_APP_PS_AMARKA_SITE + '/api/' + process.env.REACT_APP_PS_AMARKA_API_VER + '/producent';
export default function KatalogStart() {
    const [katalogprodukty, setKatalogProdukty] = useState([]);
    const producent = getProducentStorage();
    const [loading, setLoading] = useState(true);
    let params =new URLSearchParams(window.location.search);
    console.log("params.get(:" + params.get("kat")) ;
    const katalogProdukty = async () => {
        const res = await axios(DAO_PRODUCENT_URL, {
            method: 'POST',
            withCredentials: false,
            headers: {
                'Accept': 'application/json'
            },
            data: { operacja: "katalog_produkty", nip: producent.nip }
        }).then((response) => {
            if (typeof (response.data.error) != 'undefined') {
                return null;
            }
            return response.data.produkty;
        }).catch(err => console.log(err.message));
        if (res !== null) {
            setKatalogProdukty(res);
        }
        setLoading(false);
    };
    useEffect(() => {
        katalogProdukty();
    }, katalogprodukty);

    if (loading) {
        return (<><img className="d-block mx-auto ladowanie" src={process.env.PUBLIC_URL + "/img/loading.gif"} width="250px" height="250px" /></>);
    } else if (katalogprodukty && katalogprodukty.length) {
        const list = katalogprodukty.map((item, key) => {
            return (<ProduktList key={item.id_produkt} produkt={item} />);
        });
        return (
            <Table className="tabela-table" striped bordered hover size="sm">
                <tbody>
                    {list}
                </tbody>
            </Table>
        );
    } else {
        return (<>Brak produktów</>);
    }
}
